/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation PhoneNumberoRouteCreateMutation($customerAccountId: ID!, $type: CUSTOMER_TYPE!, $displayName: String!) {
  PhoneNumberoRouteCreate(customerAccountId: $customerAccountId, type: $type, displayName: $displayName) {
    message
    status
  }
}
`
